import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "@/views/Landing";
import NotFound from "@/views/NotFound";
import { langDefault } from "@/config";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: `/${langDefault}`,
  },
  {
    path: "/:locale/:invite",
    name: "profile",
    component: Landing,
  },

  {
    path: "/:locale",
    name: "home",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
